<nav class="navbar navbar-expand-lg navbar-light fixed-top custom-navbar" id="navbar">
    <div class="container-fluid">
 
        <ul class="navbar-nav text-uppercase ">
            <div class="navbar-brand-centered logo-sm">
                <!-- <a href="/homefabrics/"><img src="assets\img\NewHFLogo.png" class=""
                        alt=""></a> -->
                        <a href="javascript:void(0)" (click)="homeUrl()">
                            <img src="assets/img/NewHFLogo.png" class="logo-img" alt="">
                        </a>
            </div>
        </ul>
 
        <button class="navbar-toggler" type="button" data-toggle="collapse"
            data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false"
            aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
            <!-- <fa name="bars"></fa> -->
            <!-- <i class="fas fa-bars"></i> -->
        </button>
        <div class="collapse navbar-collapse navresponsive" id="navbarResponsive">
           
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                <li class="nav-item">
                    <a class="nav-link link-navbar" routerLink="/home" (click)="homeUrl()"
                            routerLinkActive="current">Home</a>
                </li>
                <li class="nav-item dropdown">
                    <!-- <a class="nav-link" href="javascript:void(0)" style="cursor: default"
                        id="navbarDropdown4">About Us</a> -->

                        <a class="nav-link dropdown-toggle link-navbar" routerLink="/aboutus" fragment="origin"
                            id="navbarDropdown4" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            About Us
                        </a>

                    <div class="dropdown-menu" aria-labelledby="navbarDropdown4">
                        <a class="dropdown-item nav-link" routerLink="/aboutus" fragment="origin"
                                routerLinkActive="current">Origin</a>
                            <a class="dropdown-item nav-link" routerLink="/aboutus" fragment="missionandvision"
                                routerLinkActive="current">Mission & Vision</a>
                            <a class="dropdown-item nav-link" routerLink="/aboutus" fragment="administration"
                                routerLinkActive="current">Administration Team</a>
                            <a class="dropdown-item nav-link" routerLink="/aboutus" fragment="infrastructure"
                                routerLinkActive="current">Infrastructure</a>
                            <a class="dropdown-item nav-link" routerLink="/aboutus" fragment="clients"
                                routerLinkActive="current">Clients</a>
                            <a class="dropdown-item nav-link" routerLink="/aboutus" fragment="events"
                                routerLinkActive="current">Events</a>
                        </div>
                </li>

                <li class="nav-item dropdown" *ngFor="let parentCategory of categorySearchDataList"> <a
                        class="nav-link link-navbar"
                        href="/home-fabrics-ui/home-fabrics-project/#/category/26/null"
                        id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false"> {{parentCategory.parentCategoryName}} </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li class="dropdown-submenu " *ngFor="let category of parentCategory.categories"> <button
                                [ngClass]="category.categoryName!=null && category.subCategories==null ? 'dropdown-item nav-link': 'dropdown-item nav-link rtarrow'"
                                (click)="categoryDetailsUrl(category.categoryId,category.categoryName, $event)">
                                {{category.categoryName}}</button>
                            <ul class="dropdown-menu">
                                <li *ngFor="let subCategory of category.subCategories"><button
                                        class="dropdown-item nav-link "
                                        (click)="categoryDetailsUrl(subCategory.categoryId,subCategory.subCategoryName, $event)">
                                        {{subCategory.subCategoryName}}</button>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <li class="nav-item ">
                    <a class="nav-link link-navbar" routerLink="/custom-design" (click)="CustomDesign()" routerLinkActive="current">
                        Custom Design
                    </a>
                </li>
                <li class="nav-item ">
                    <a class="nav-link link-navbar" routerLink="/contactUs" (click)="feedbackUrl('Contact Us')"
                        routerLinkActive="current">
                        Contact
                    </a>
                </li>
                <li class="nav-item dropdown login">
                    <a class="nav-link dropdown-toggle login-toggle" href="#" id="navbarDropdown3" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span>
                            <!-- <fa name="user-o"></fa> -->
                            <i class="far fa-user"></i>
                        </span>
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown3">
                        <a class="dropdown-item  login-menu" *ngIf="!isToken()" routerLink="/login">Sign in</a>
                        <a class="dropdown-item  login-menu" *ngIf="!isToken()" routerLink="/signup">Sign up</a>
                        <a class="dropdown-item   login-menu" *ngIf="isToken()" (click)="onLogout()">Sign Out</a>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</nav>
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
 
<!-- <div class=" container no-padding"> -->
 
<!-- Top navigation bar contains static pages -->
<!-- <div class="row ">
        <div class="col-md-12 col-xl-12 col-sm-12 col-xs-12 ">
            <mat-toolbar class="single-row">
                <span class="example-fill-remaining-space"></span>
 
                <form [formGroup]="productSearchFormGroup">
                   
                    <div class="search-box">
                        <input type="text" class="search-txt" formControlName="search" placeholder="Search">
                        <button matButton href="#" class="search-btn" (click)="selectedValue()">
                            <i class="material-icons color-change" matToolTip="Search">search</i>
                        </button>
                    </div>
                </form>
                <span class="example-fill-remaining-space"></span>
                <div fxShow="true" fxHide.lt-md="true">
                    <button mat-button [routerLink]="['']" class="menu-top" routerLinkActive="current">Home</button>
                    <button mat-button [routerLink]="['/aboutus']" class="menu-top" routerLinkActive="current">About
                        us</button>
                    <button mat-button routerLink="/contactUs" (click)="feedbackUrl('Contact Us')" class="menu-top"
                        routerLinkActive="current">Contact us</button>
                </div>
 
 
            </mat-toolbar>
 
        </div>
 
    </div> -->
 
<!-- Navigation for collection, search bar, login & signup and different categories based on selection -->
<!-- <div class="row">
 
        <div class="col-md-12 col-xl-12 col-sm-12 col-xs-12 ">
            <mat-toolbar class="single-row-top-nav">
                    <img style="outline: none" src="assets\img\logo.jpg" routerLink="/home">
                    <button mat-icon-button (click)="sidenav.toggle()" fxShow="true" fxHide.gt-sm>
                        <mat-icon>menu</mat-icon>
                    </button>
                   
                    <div class="row " fxShow="true" fxHide.lt-md="true">
                        <ng-container *ngFor="let parentCategory of categorySearchDataList">
                            <div class="col-md-2">
                                <button mat-menu-item [matMenuTriggerFor]="afterMenu"
                                    (mouseover)="menuTrigger.openMenu()"
                                    #menuTrigger="matMenuTrigger">{{parentCategory.parentCategoryName}}</button>
                                <mat-menu #afterMenu="matMenu" [overlapTrigger]="false" >
 
                                    <ng-container *ngFor="let category of parentCategory.categories;let i =index" >
                                            <button mat-menu-item
                                            *ngIf="category.categoryName!=null && category.subCategories==null"
                                            (click)="categoryDetailsUrl(category.categoryId,category.categoryName) ">{{category.categoryName}}</button>
                                        <button mat-menu-item *ngIf="category.subCategories!=null"
                                            [matMenuTriggerFor]="submenu"
                                            (click)="categoryDetailsUrl(category.categoryId,category.categoryName) ">{{category.categoryName}}</button>
                                     
                                        <mat-menu #submenu="matMenu">
                                            <span (mouseleave)="menuTrigger.closeMenu()">
                                                <ng-container *ngFor="let subCategory of category.subCategories">
                                                    <button mat-menu-item
                                                        (click)="categoryDetailsUrl(subCategory.categoryId,subCategory.subCategoryName) ">
                                                        {{subCategory.subCategoryName}}</button>
                                                </ng-container>
                                            </span>
                                        </mat-menu>
                                    </ng-container>
                                </mat-menu>
                            </div>
                        </ng-container>
                    </div>
                    <span class="example-fill-remaining-space"></span>
 
                    <div class="example-full-width" *ngIf="isToken()">
                        <p style="color: #691883;font-weight: bold;">Welcome {{ currentUser.jti }}</p>
                    </div>
 
                   
                    <span class="tool-menu ">
                        <button mat-button [matMenuTriggerFor]="menu">
                            <i class="material-icons">
                                account_circle
                            </i>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item *ngIf="isToken()" routerLink="/">My Profile</button>
                            <button mat-menu-item *ngIf="!isToken()" routerLink="/login">Log In</button>
                            <button mat-menu-item *ngIf="!isToken()" routerLink="/signup">Signup</button>
                            <button mat-menu-item *ngIf="isToken()" (click)="onLogout()" routerLink="/home">Log
                                Out</button>
                        </mat-menu>
                    </span>
            </mat-toolbar>
            <mat-sidenav-container fxFlexFill>
                <mat-sidenav #sidenav>
                    <mat-nav-list>
                        <button mat-menu-item [routerLink]="['']">Home</button>
                        <button mat-menu-item [routerLink]="['/aboutus']">About us</button>
                        <button mat-menu-item routerLink="/contactUs" (click)="feedbackUrl('Contact Us')">Contact
                            us</button>
                        <hr>
                        <ng-container *ngFor="let parentCategory of categorySearchDataList">
                            <div>
                                <button mat-menu-item [matMenuTriggerFor]="afterMenu"
                                    (mouseover)="menuTrigger.openMenu()"
                                    #menuTrigger="matMenuTrigger">{{parentCategory.parentCategoryName}}</button>
                                <mat-menu #afterMenu="matMenu" [overlapTrigger]="false">
 
                                    <ng-container *ngFor="let category of parentCategory.categories;let i =index">
                                        <button mat-menu-item
                                            *ngIf="category.categoryName!=null && category.subCategories==null"
                                            (click)="categoryDetailsUrl(category.categoryId,category.categoryName) ">{{category.categoryName}}</button>
                                        <button mat-menu-item *ngIf="category.subCategories!=null"
                                            [matMenuTriggerFor]="submenu"
                                            (click)="categoryDetailsUrl(category.categoryId,category.categoryName) ">{{category.categoryName}}</button>
                                        <mat-menu #submenu="matMenu">
                                            <span (mouseleave)="menuTrigger.closeMenu()">
                                                <ng-container *ngFor="let subCategory of category.subCategories">
                                                    <button mat-menu-item
                                                        (click)="categoryDetailsUrl(subCategory.categoryId,subCategory.subCategoryName) ">
                                                        {{subCategory.subCategoryName}}</button>
                                                </ng-container>
                                            </span>
                                        </mat-menu>
                                    </ng-container>
                                </mat-menu>
                            </div>
                        </ng-container>
                     
                    </mat-nav-list>
                </mat-sidenav>
                <mat-sidenav-content fxFlexFill>
                    <router-outlet></router-outlet>
                </mat-sidenav-content>
            </mat-sidenav-container>
        </div>
 
    </div> -->
 
 
<!-- </div> -->